import React from 'react';
import {
  getPluginType,
  someNode,
  useEventPlateId,
  usePlateEditorState,
  ELEMENT_LINK,
  triggerFloatingLink,
} from '@udecode/plate';

import { ToolbarButton } from './ToolbarButton';

export const LinkToolbarButton = ({
  id,
  getLinkUrl,
  ...props
}) => {
  const editor = usePlateEditorState(useEventPlateId(id));

  const type = getPluginType(editor, ELEMENT_LINK);
  const isLink = !!editor?.selection && someNode(editor, { match: { type } });

  return (
    <ToolbarButton
      name="Create link"
      active={isLink}
      disabled={isLink}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        triggerFloatingLink(editor, { focused: true });
      }}
      {...props}
    />
  );
};
